import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import numeral from 'numeral';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import axios from 'axios';
import { Grid, Hidden } from '@material-ui/core';
// app
import { updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar, setSignup } from '../../store/action-creators';
// containers
import AppContainer from '../../containers/App';
// models
import { Auth, Session, Signup } from '../../entities/auth';
import { APIUrl } from '../../entities/site';
// components
import Loading from '../../components/site/Loading';
import Industries from './components/Industries';
import TopSection from './components/TopSection';
import TopSectionAlt from './components/TopSectionAlt';
import LeftBanner from './components/LeftBanner';
import RightBanner from './components/RightBanner';
import FullImage from './components/FullImage';
import SpeedToLead from './components/SpeedToLead';

// https://maps.googleapis.com/maps/api/place/autocomplete/json?input=1217&location=38.6490368,-121.1826176&radius=500&key=AIzaSyD2ef311rLt_ylXiP6raAeD43ElCvLhkX4


const useProd = false;

// images
const cellphone = process.env.PUBLIC_URL + '/home_page/img_hero.png';
// banner 1
const mapImg = process.env.PUBLIC_URL + '/home_page/img_radius.png';
// banner 2
const abTestingImg = process.env.PUBLIC_URL + '/home_page/img_abtest.png';
// banner 3
const oldDataImg = process.env.PUBLIC_URL + '/home_page/img_recycledata.png';
// banner 4
const iconRobot = process.env.PUBLIC_URL + '/images/home/img_robot.svg';


const crtTemplateImg = process.env.PUBLIC_URL + '/home_page/img_templates.png';


const logo = process.env.PUBLIC_URL + '/galilaio/logo.png';
const cashLogo = process.env.PUBLIC_URL + '/galilaio/cash_flow_1.png';
const refiLogo = process.env.PUBLIC_URL + '/galilaio/refi.png';
const pmiLogo = process.env.PUBLIC_URL + '/galilaio/pmi_removal.png';
const dreamRate = process.env.PUBLIC_URL + '/galilaio/dream_rate.png';

const styles: any = {
  container: {
    flex: 1,
    height: "100%",
    minHeight: "100%"
  },
  bannerContainer: {
    width: '80%',
    margin: '0px auto'
  },
  bannerTextContainer: {
    // padding: 100,
  },
  title: {
    color: '#2e3d54',
    fontSize: 26,
    textAlign: 'left',
    fontWeight:'bold'
  },
  subTitle: {
    color: '#acb8c7',
    fontSize: 24,
    textAlign: 'left',
    paddingTop: 40,
    paddingBottom: 40
  },
  section:{
    padding:30
  },
  sectionTitle: {
    paddingTop: 60,
    paddingBottom: 40,
    fontSize: 24,
    color: '#00ABCA',
    textAlign: 'center'
  },
  flexBox:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop:40,
    width: "100%"  
  },
  max90:{
    maxWIdth:'90%'
  },
  button: {
    width: 240,
    height: 50,
    borderRadius: 4,
    border: 'none',
    backgroundColor: '#00ABCA',
    fontSize: 20,
    fontFamily: 'Asap',
    textAlign: 'center',
    color: '#FFFFFF',
    cursor: 'pointer'
  },
  chooseTemplateText: {
    color: '#5A728F',
    fontFamily: 'Asap',
    fontSize: '34px',
    letterSpacing: 0,
    textAlign: 'center',
    padding:"0 30px",
    maxWidth:1100
  },
  fullImage:{
    maxWidth:"100%"
  },
  templateContainer:{
    maxWidth:1100,
    margin:"auto"
  },
  imgContainer:{
    maxWidth:906,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}

interface HomePageProps {
  history: any;
  auth: Auth;
  session: Session;
  signup: Signup;
  apiUrls: APIUrl;
  setSignup(username: string, email: string, name: string, phone: string, isReset: boolean): void;
  addAuth(auth: Auth): void;
  updateSession(session: Session): void;
  setApiUrls(urls: APIUrl): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface HomePageState {
  email: string;
  address: string;
  loading: boolean;
  signup: boolean;
}

class HomePage extends Component<HomePageProps, HomePageState> {

  constructor(props: HomePageProps) {
    super(props);
    this.state = {
      email: '',
      address: '',
      loading: false,
      signup: false
    }
  }

  componentDidMount = () => {
    // get location
    this.getLocation();
  }

  getLocation = () => {
    const newSession = this.props.session;
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        newSession.coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
        this.props.updateSession(newSession);
      }, (error) => {
        axios.get('http://ip-api.com/json').then((res) => {
          newSession.coords = {
            latitude: res.data.lat,
            longitude: res.data.lon
          }
          this.props.updateSession(newSession);
        });
      });
    } else {
      axios.get('http://ip-api.com/json').then((res) => {
        newSession.coords = {
          latitude: res.data.lat,
          longitude: res.data.lon
        }
        this.props.updateSession(newSession);
      });
    }
  }

  handleShowLoading = () => {
    this.setState({ loading: true });
  }

  handleCampaignClick = () => {
    this.props.history.push(`/campaign/new/start`);
  }

  handleAction = (action: string, route: string) => {
    if (action === 'signup') {
      this.setState({signup: true});
    }
    if (action === 'close') {
      this.setState({signup: false});
    }
  }

  render() {

    const email = (!isEmpty(this.props.signup) && !isEmpty(this.props.signup.email) ? this.props.signup.email : '');

    return (
      <AppContainer 
        showOption={false} 
        private={false} 
        maxWidth="xl" 
        openSignup={this.state.signup} 
        largeFooter
        onAction={this.handleAction}
      >
        <Loading open={this.state.loading} />
          <TopSection onClick={this.handleAction}/>
          <RightBanner
            title="Radius Campaigns"
            text="Pinpoint a specific location and communicate to all in a particular zone."
            link="Create Campaign"
            banner={mapImg}
            onClick={this.handleAction}
          />
           <SpeedToLead 
            title="Speed to Lead"
            onClick={this.handleAction}
           />
           <Industries />
      </AppContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    signup: state.auth.signup,
    apiUrls: state.site.apiUrls
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar, setSignup }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(HomePage));



// WEBPACK FOOTER //
// ./src/pages/home/Home.tsx